import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["id", "ignoreMetaId", "limit"],
    _excluded2 = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Slider from "@/components/Slider";
import { useChannelLinearEpisodesQuery } from "@/hooks";
import Card from "@/components/Card/index";
import { SLIDER_MAX_NUM } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ChannelLinearEpisodesSlider(_ref) {
  var _items$data;

  var id = _ref.id,
      ignoreMetaId = _ref.ignoreMetaId,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? SLIDER_MAX_NUM : _ref$limit,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useChannelLinearEpis = useChannelLinearEpisodesQuery({
    variables: {
      offset: 0,
      limit: limit,
      id: id,
      filter: {
        not: {
          meta_id: ignoreMetaId
        }
      }
    }
  }),
      data = _useChannelLinearEpis.data,
      result = _objectWithoutProperties(_useChannelLinearEpis, _excluded2);

  var items = data === null || data === void 0 ? void 0 : data.channelLinearEpisodes;
  if ((items === null || items === void 0 ? void 0 : (_items$data = items.data) === null || _items$data === void 0 ? void 0 : _items$data.length) === 0) return null;
  return /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread(_objectSpread({}, props), result), {}, {
    itemComponent: Card,
    items: items
  }));
}